import { AlertTriangle } from "lucide-react";

// Callout box for "unknown" values — shown separately from charts
export const UnknownCallout = ({ count, total, label, note }) => {
  const pct = total > 0 ? (count / total * 100).toFixed(1) : "0";
  return (
    <div
      data-testid={`unknown-callout-${label.replace(/\s/g, "-")}`}
      className="mt-3 flex items-start gap-3 px-3 py-2.5 rounded-lg bg-amber-500/5 border border-amber-500/15"
    >
      <AlertTriangle className="w-3.5 h-3.5 text-amber-400/70 mt-0.5 flex-shrink-0" />
      <div className="text-xs leading-relaxed text-muted-foreground">
        <span className="text-amber-400/80 font-semibold tabular-nums">
          {count.toLocaleString()} apps ({pct}%)
        </span>{" "}
        have unknown {label}. {note}
      </div>
    </div>
  );
};

export default UnknownCallout;
